import bankAccounts from './bankAccounts'
import exportLabels from './exportLabels'
import info from './info'
import menu from './menu'
import settings from './settings'
import table from './table'

export default {
    organisationId: 'Organisation {id}',
    organisationGeneral: 'Allgemein',
    organisationAddress: 'Adresse',
    organisationContactPerson: 'Kontaktperson',
    organisationAcceptTransferAgreement: 'Weitergabevertrag akzeptiert',
    organisationConnections: 'Verknüpfungen',
    organisationBankAccount: 'Bankverbindung',
    organisationUsers: 'Nutzer',

    membersCount: 'Nutzer',

    name: 'Name',
    parent_organisation_id: 'Übergeordnete Organisation',
    searchParentOrganisation: 'Suche nach Name, PLZ, Ort',
    carrier_type_id: 'Art des Trägers',
    carrier_legal_form_id: 'Rechtsform des Trägers',
    parish_number: 'Pfarrbezirksnummer',
    active: 'Aktiv',
    street: 'Straße',
    house_number: 'Hausnummer',
    zipcode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    ags: 'Gemeindeschlüssel',
    contact_person_firstname: 'Vorname',
    contact_person_lastname: 'Nachname',
    contact_person_email: 'E-Mail',
    contact_person_phone: 'Telefon',
    organisation_id: 'Organisation',
    user_id: 'Nutzer',
    role_name: 'Rolle',

    category_id: 'Kategorie Id',
    tags: 'Tags',

    form: {
        general: {
            name: 'Name',
            id: 'ID',
            parentOrganisation: 'Übergeordnete Organisation',
            noParentOrganisation: 'Keine übergeordnete Organisation',
            searchParentOrganisation: 'Suche nach Name, PLZ, Ort',
            type: 'Organisationstyp',
            types: {
                organisation: 'Standardorganisation',
                association: 'Verband',
                rp: 'Regierungspräsidium'
            },
            carrierType: 'Art des Trägers',
            carrierTypePlaceholder: 'Bitte wählen...',
            carrierLegalForm: 'Rechtsform des Trägers',
            carrierLegalFormPlaceholder: 'Bitte wählen...',
            parishNumber: 'Pfarrbezirksnummer',
            sportbizzId: 'SportBizz ID',
            sportbizzNo: 'SportBizz Nummer',
            statistic_identifier: 'Statistische Kennnummer der Berichtsstelle',
            active: 'Aktiv',
            auth_code: 'Authentifizierungscode',
        },

        address: {
            street: 'Straße',
            houseNumber: 'Hausnummer',
            zipcode: 'Postleitzahl',
            city: 'Stadt',
            country: 'Land',
            foreignAddress: 'Ausländische Adresse',
            ags: 'Gemeindeschlüssel',
            agsAutoFilled: 'Der Gemeindeschlüssel wird automatisch generiert.'
        },

        contactPerson: {
            firstname: 'Vorname',
            lastname: 'Nachname',
            email: 'E-Mail',
            phone: 'Telefon'
        },

        transferAgreement: {
            useTransferAgreement: 'Weitergabevertrag nutzen',
            useTransferAgreementDescription: 'Aktiviere diese Option, wenn du einen Weitergabevertrag hinterlegt hast und diesen verwenden möchtest.',
            allowDigitalSignature: 'Digitale Unterschrift erlauben',
            allowDigitalSignatureDescription: 'Aktiviere diese Option, wenn Organisationen den Weitergabevertrag digital unterschreiben dürfen.',

            transferAgreementUpload: {
                title: 'Weitergabevertrag',
                description: 'Hinterlege die Standard Word Vorlage (docx-Format) für die PDF-Generierung der Weitergabeverträge',
                placeholderDescription: 'Es stehen dir folgende Platzhalter zur Verfügung:'
            },

            attachmentsUpload: {
                title: 'Anlagen',
                description: 'Lade Anlagen als PDF-Datei hoch'
            },
        }
    },

    saveSuccess: 'Organisation wurde erfolgreich gespeichert.',

    deleteOrganisation: 'Organisation löschen',
    deleteOrganisationText:
        'Möchtest du die Organisation wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOrganisationSuccess: 'Organisation wurde erfolgreich gelöscht.',
    deleteOrganisationError: 'Die Organisation konnte nicht gelöscht werden.',
    transferOrDeleteUsers: 'Die Nutzer der Organisation können entweder gelöscht oder einer anderen Organisation zugewiesen werden.',
    selectOrganisation: 'Wähle eine Organisation',
    cantDeleteCurrentOrganisation: 'Du kannst deine aktive Organisation nicht löschen.',
    cantDeleteOrganisationWithChildren: 'Die Organisation kann nicht gelöscht werden, da sie noch untergeordnete Organisationen hat.',

    toggleState: 'aktivieren / deaktivieren',
    toggleStateSuccess: 'Status wurde erfolgreich geändert.',
    toggleStateError: 'Der Status konnte nicht geändert werden.',

    print: {
        noDocumentCouldBeExported: 'Es konnte kein Dokument zur Ansicht gefunden oder erzeugt werden.',
        exportError: 'Fehlende Vorlage',
    },

    transferAgreement: {
        description: 'Der Weitergabevertrag ist für die Zuschussabrechnung erforderlich. Gib zunächst den Namen und die Funktion der unterschreibenden Person an.',
        nameAndFunction: 'Name, Funktion der unterschreibenden Person',
        nameAndFunctionDescription: 'Die unterschreibende Person muss unterschriftsberechtigt sein.',
    },

    manuallyAcceptTransferAgreement: {
        title: 'Manuelle Unterschrift',
        description: 'Lade den Vertrag herunter, unterschreibe ihn und sende ihn dann per Post an deinen Verband.',
        downloadTransferAgreement: 'Weitergabevertrag herunterladen',
        setAsSignedDescription: 'Liegt dir als Verband der unterschriebene Weitergabevertrag in anderer Form vor?\nDann kannst du hier manuell den Weitergabevertrag als "unterschrieben" markieren.',
        setAsSignedButton: 'Unterschriebener Weitergabevertrag liegt mir in anderer Form vor',
        success: 'Der Weitergabevertrag wurde als unterschrieben markiert.',
        error: 'Der Weitergabevertrag konnte nicht als unterschrieben markiert werden.',
    },

    uploadSignedTransferAgreement: {
        title: 'Unterschriebenen Weitergabevertrag hochladen',
        success: 'Der unterschriebene Weitergabevertrag wurde erfolgreich gespeichert.',
        error: 'Der unterschriebene Weitergabevertrag konnte nicht gespeichert werden.',
    },

    acceptTransferAgreement: {
        title: 'Digitale Unterschrift',
        description: 'Unterschreibe direkt hier in der App.',
        signTransferAgreement: 'Weitergabevertrag unterschreiben',
        scanQrCode: 'Scanne den QR-Code um den Weitergabevertrag zu unterschreiben.',
        missingScanningDevice: 'Kein Gerät zum einscannen?',
        signOnThisDevice: 'Auf diesem Gerät unterschreiben'
    },

    noTransferAgreementRequired: 'Dein Verband nutzt keinen Weitergabevertrag.',

    transfer_agreement_signature_title: 'Unterschrift Weitergabevertrag',
    transfer_agreement_signature_description: 'Hiermit bestätigst du, dass du den Weitergabevertrag gelesen hast und diesen akzeptierst.',

    transferAgreementSignedAt: 'Der Weitergabevertrag wurde am {date} unterschrieben.',
    transferAgreementManuallySignedAt: 'Der unterschriebene Weitergabevertrag ist am {date} beim Verband eingegangen.',
    transferAgreementOutdated: 'Der Weitergabevertrag ist veraltet. Bitte lösche den alten Vertrag und unterschreibe den neuen.',

    deleteSignedTransferAgreement: 'Unterschriebenen Weitergabevertrag löschen',
    deleteSignedTransferAgreementText: 'Möchtest du den unterschriebenen Weitergabevertrag wirklich löschen?',
    deleteSignedTransferAgreementSuccess: 'Unterschriebener Weitergabevertrag wurde erfolgreich gelöscht.',
    deleteSignedTransferAgreementError: 'Der unterschriebene Weitergabevertrag konnte nicht gelöscht werden.',

    viewTransferAgreement: 'Weitergabevertrag ansehen',
    deleteTransferAgreement: 'Unterschriebenen Weitergabevertrag löschen',

    bankAccounts,
    exportLabels,
    info,
    menu,
    settings,
    table,
}